import React, { Component, ReactNode } from 'react';
import './PrimaryButton.css';
import { faEdit, faPlusCircle, faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface Props {
  icon?: string;
  isDisabled?: boolean;
  label: string;
  onClick(): void;
  fullWidth?: boolean;
}

export class PrimaryButton extends Component<Props, never> {
  getIcon = (): ReactNode => {
    const { icon = '' } = this.props;
    if (icon === 'edit-icon') {
      return <FontAwesomeIcon icon={faEdit} size="lg" color="#ffffff" />;
    }
    if (icon === 'add-icon') {
      return <FontAwesomeIcon icon={faPlusCircle} size="lg" color="#ffffff" />;
    }
    if (icon === 'save-icon') {
      return <FontAwesomeIcon icon={faSave} size="lg" color="#ffffff" />;
    }
    if (icon === 'back-icon') {
      return <FontAwesomeIcon icon={faArrowLeft} size="lg" color="#ffffff" />;
    }
    return null;
  };

  render() {
    const { label, icon, isDisabled = false, onClick, fullWidth = false } = this.props;
    const buttonClass: string = fullWidth ? 'primary-button full-width' : 'primary-button';
    const textClass = icon ? 'primary-button__text' : 'primary-button__text--no-icon';

    return (
      <button type="button" className={buttonClass} disabled={isDisabled} onClick={onClick}>
        <span className="primary-button-contents">
          {this.getIcon()}
          <span className={textClass}>{label}</span>
        </span>
      </button>
    );
  }
}
